// extracted by mini-css-extract-plugin
export default {"App":"App_App__3bbu8","switch-wrapper":"App_switch-wrapper__B3f3g"};